import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { addToast } from '../../../Toasts/actions'

import {
  fetchVipUsersError,
  fetchVipUsersSuccess,
  updateVipUsersEpicError,
  updateVipUsersEpicSuccess,
} from './actions'
import { DATA_REQUEST_ASYNC, UPDATE_DATA_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DATA_REQUEST_ASYNC.INITIATE, UPDATE_DATA_REQUEST_ASYNC.SUCCESS),
    mergeMap(() =>
      api.mailboxes.getVipUsersData(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => fetchVipUsersSuccess(response)),
        catchError((error) => of(epicsErrorHandler(fetchVipUsersError, error))),
        takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updateVipUsersEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_DATA_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .updateVipUsersData(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.data?.map((e) => [e.profileId, e.title, !e.selected])
        )
        .pipe(
          mergeMap((response) => {
            if (response.response.vipProfilesLength) {
              return of(
                addToast({
                  message:
                    "'vip_impersonation' tags were successfully added to the selected profiles",
                }),
                updateVipUsersEpicSuccess(response)
              )
            } else {
              return of(updateVipUsersEpicSuccess(response))
            }
          }),
          catchError((error) => of(epicsErrorHandler(updateVipUsersEpicError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_DATA_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(fetchDataEpic, updateVipUsersEpic)
